import { OrderDirection } from '~api/som';

import { NavLink } from 'react-router-dom';

import { Breadcrumb, InteractiveTable, PageTitle, PageWrapper, PaginationProvider } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { useDebounce } from '~src/lib/hooks/useDebounce';
import { usePagination } from '~src/main/hooks/usePagination';

import { usePendingShipmentListQuery } from '../queries';
import { Filters } from './filters/filters';
import { usePendingShipmentListFilter } from './filters/usePendingShipmentListFilter';
import { ListTable } from './list-table';
import { ListTableBar } from './list-table-bar';

export function Page() {
  const { pageIndex, pageSize, direction, setPageSize, setPageIndex } = usePagination();
  const { search } = usePendingShipmentListFilter();
  const { t } = useTranslation();

  const {
    data = [],
    isFetched,
    isFetching,
  } = usePendingShipmentListQuery({
    order_by_direction: direction.toUpperCase() as OrderDirection,
    pageIndex: pageIndex - 1,
    pageSize: pageSize,
    filtering: {
      id: useDebounce(search, 300),
    },
  });

  return (
    <InteractiveTable.Provider onSelectedKeysChange={undefined} selectedKeys={undefined} allowHighlight keepInactive>
      <PaginationProvider
        onPageSizeChange={setPageSize}
        onPageNoChange={setPageIndex}
        pageSize={pageSize}
        pageNo={pageIndex}
      >
        <PageWrapper>
          <PageTitle.Wrapper>
            <PageTitle.Stack>
              <Breadcrumb aria-label={t('common.breadcrumbs')}>
                <NavLink to="..">{t('common.settings')}</NavLink>
                <a aria-current="page">{t('common.pendingShipments')}</a>
              </Breadcrumb>
            </PageTitle.Stack>
          </PageTitle.Wrapper>

          <Filters />

          <section style={{ backgroundColor: 'inherit' }}>
            <ListTableBar />

            <ListTable
              isEmpty={isFetched && !data?.length}
              pendingShipments={data}
              loadRowCount={pageSize}
              loading={isFetching}
            />
          </section>
        </PageWrapper>
      </PaginationProvider>
    </InteractiveTable.Provider>
  );
}
